import styled from 'styled-components';

export const AvatarContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 99999px;
  overflow: hidden;
  background-clip: padding-box;
  height: 36px;
  width: 36px;
  background-color: #556ee6;
  color: white;
  animation: none;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &[data-is-loading='true'] {
    span {
      display: none;
    }
    background-color: #f8f9fa;
    animation: loading-img 2s alternate-reverse infinite;
  }

  @keyframes loading-img {
    0% {
      background-color: #f8f9fa;
    }
    50% {
      background-color: #f6f6f6;
    }
    100% {
      background-color: #adb5bd;
    }
  }
  &[data-assigned='false'] {
    background-color: transparent !important;
  }

  &[data-has-photo='true'] {
    span {
      display: none;
    }
  }
  span {
    font-size: 1rem;
  }
`;

const Styles = {
  AvatarContainer,
};

export default Styles;
